import React from 'react';
import PropTypes from 'prop-types';
import { Type, Stack } from 'react-spark';
import { ExclamationIcon } from '../../icons';
import { FONT_SIZES } from '../../../../utils/novaTypography';

export const OffersV3NotificationBanner = ({ title, message }) => {
    return (
        <div className="sprk-u-mbh" style={{ 
            backgroundColor: '#FFF5E4',
            borderRadius: '16px',
            boxShadow: '0 10px 20px 0 rgba(0, 0, 0, 0.02)',
            padding: '20px',
            display: 'flex',
            alignItems: 'flex-start',
            border: '1px solid #FED48D'
        }}>
            <ExclamationIcon style={{ 
                color: '#A56A06', 
                marginRight: '12px', 
                marginTop: '-5px', 
                flexShrink: 0, 
                width: '24px', 
                height: '24px' 
            }} />
            <Stack>
                <Stack.Item>
                    <Type.DisplayFive className="sprk-u-mtn" style={{ fontSize: FONT_SIZES.subtitle }}>
                        {title}
                    </Type.DisplayFive>
                </Stack.Item>
                <Stack.Item>
                    <Type.BodyFour className='sprk-u-mvn' style={{ fontSize: FONT_SIZES.body, lineHeight: 1.25 }}>
                        {message}
                    </Type.BodyFour>
                </Stack.Item>
            </Stack>
        </div>
    );
};

OffersV3NotificationBanner.propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
};
